import { createAsyncThunk } from '@reduxjs/toolkit'
import { articleManagementAPI } from '@services/api'

export const fetchArticleList = createAsyncThunk(
  'articleManagement/fetchList',
  async (params: TArticleManagementAPI.Params.FetchList, { rejectWithValue }) => {
    try {
      const response = await articleManagementAPI.fetchList(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchArticleSingle = createAsyncThunk(
  'articleManagement/fetchArticleSingle',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await articleManagementAPI.fetchSingle(id)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)
